import { StudentsIndividualWorklodReport } from 'presentation/app/modules/Reports/pages/students/students-individual-workload-report';

export const MakeStudentsIndividualWorkloadReport: React.FC = () => {
  return <StudentsIndividualWorklodReport />;
};
